import React from 'react';
import { ViewMode } from '../types';
import { SiteContent } from '../data/content';

interface ModeBannerProps {
  viewMode: ViewMode;
  onToggleMode: () => void;
  content: SiteContent['modeBanner'];
}

export const ModeBanner: React.FC<ModeBannerProps> = ({
  viewMode,
  onToggleMode,
  content,
}) => {
  return (
    <aside className="mode-editorial-banner" aria-label="CV Mode Switcher">
      <div className="container">
        <div className="mode-banner-inner">
          <div className="mode-banner-copy">
            <span className="mode-badge-mono">
              {viewMode === '30sec' ? content.title30s : 'FULL CV MODE ACTIVE'}
            </span>
            <p className="mode-banner-desc">
              {viewMode === '30sec' ? content.desc30s : content.switchPrompt}
            </p>
          </div>

          <button
            type="button"
            className="mode-banner-btn"
            onClick={onToggleMode}
          >
            {viewMode === '30sec' ? content.switchToFull : content.switchTo30s}
          </button>
        </div>
      </div>
    </aside>
  );
};
